import { OPERATORS_FILTERS } from "../../../shared/constants/GeneralConstants";
import { FILTER_DISPLAY } from "../../Dashboards/AdminDashboard/constants/AdminDashboardConstants";
import { SecondaryFilter } from "../../Dashboards/AdminDashboard/models/SecondaryFilter";

export const LIST_CONSTANTS = {
  PAGE_TITLE: "Listas",
  PAGE_TITLE_ADD: "Crear lista",
  PAGE_EDIT_TITLE: "Editar lista",
  PAGE_TITLE_SEARCH: "Consulta de listas",
  ADD_OPTION: "Agregar opción",
  EDIT_OPTION: "Editar opción",
  USERS_STATES_LIST_NAME: "Estados de usuarios",
  SERVICE_STATES_LIST_NAME: "Estados de servicios",
  SESSION_STATES_LIST_NAME: "Estados de sesiones",
  ORDER_STATES_LIST_NAME: "Estados de órdenes",
  LEADS_TYPE_LIST_NAME: "Tipo de prospectos",
  WEBHOOK_LIST_NAME: "Webhooks",
  OPTIONS_TITLE: "Opciones",
  LABEL: {
    LIST_NAME: "Nombre lista *",
    LIST_ADITIONAL_CONFIG: "Configuración adicional",
    ADD_LIST: "Tipo de lista *",
    SEARCH_LIST: "Búsqueda tipo de lista",
    OPTION_TITLE: "Título *",
    OPTION_VALUE: "Valor *",
    OPTION_SCORE: "Puntaje",
    OPTION_URL_ICON: "Icono",
    OPTION_STATE: "Estado",
    OPTIONS_INFO: "Información adicional de la opción"
  },
  HINT: {
    LIST: "Escriba el nombre de la lista y presiona enter para buscar",
    SEARCH_LIST: "Seleccione una lista"
  },
  BUTTON: {
    ADD_OPTIONS: "Agregar opción",
    ADD_LIST_TEXT: "Crear lista"
  },
  RULES_MESSAGE: {
    MAX_LENGTH_50: "El tamaño máximo es de 50 caracteres",
    NAME_EXIST: "Ya se encuentra una opción con ese nombre",
    VALUE_EXIST: "Ya se encuentra una opción con ese valor"
  },
  DIALOG_MESSAGE: {
    MIN_OPTIONS: "Debe agregar al menos una opción",
    LIST_NAME_EXIST: "Ya existe una lista con este nombre",
    SAVE_LIST_OK: "Lista almacenada correctamente",
    ERROR_SAVE_LIST: "Ocurrió un error al guardar",
    DELETE_LIST_OK: "Lista eliminada correctamente",
    ERROR_ID_NOT_FOUND: "La lista a eliminar no existe",
    NOT_FOUND: "No se encontraron listas con estos parámetros",
    DEFAULT_LIST_NOT_FOUND: "No se encontró la lista de categorías",
    CATEGORY_NOT_FOUND: "No se encontraron categorías",
    ERROR_EDIT_ID_NOT_FOUND: "La lista a editar no existe",
    ERROR_SAVE_DELETE_LIST:
      "Ocurrió un error al guardar el nuevo motivo de eliminacion",
    LIST_USED: "La lista está en uso, no puede ser borrada."
  },
  LIST_VALIDATORS: {
    MAX_LENGTH: (v: string) =>
      v.length <= 50 || LIST_CONSTANTS.RULES_MESSAGE.MAX_LENGTH_50
  },
  DELETE_REASON_MODAL: {
    TITLE: "Eliminar lista",
    MESSAGE: "Ingrese la razón por la cual va a deshabilitar la lista: "
  },
  OPTIONS_INFO: {
    NAME: "Nombre: ",
    VALUE: "Valor: ",
    STATE: "Estado: ",
    SCORE: "Puntaje: "
  },
  WHITE_COLOR: "#FFFFFF",
  LIST_COLOR_TOOLTIP: "Color de Lista",
  INFO_TOOLTIP: "Ayuda",
  ICON_SHAPE: "mdi-format-color-fill",
  HELP_ICON_SHAPE: "mdi-help-circle-outline",
  SWITCH_OFF: "mdi-toggle-switch-off-outline",
  COLOR: "Color",
  TEXT_INFO: {
    INFO: "Información",
    DETAILS: "Especificaciones",
    CATEGORY: "¿Es Categoria?",
    CATEGORY_INFO:
      "Sirve para agrupar una lista dentro de otra, pudiendo mostrar por categoria ó subcategoria",
    COLOR: "Color de Lista",
    COLOR_INFO:
      "Sirve para poner color a la subcategoria y en la lista de documentos este color se visualizaria."
  },
  REFERENCES_TEXTS: {
    CLOSE_MODAL: "closeModal",
    OPTIONS_CONTAINER: "optionsContainer",
    ADD_OPTION: "addOption",
    ADD_LIST: "addList",
    EDIT_LIST: "editList",
    SAVE_LIST: "saveList",
    EDIT_TITLE: "editTitle"
  },
  LIST_FILTERS: {
    MAIN: {
      mainFilterKey: "all",
      mainFilterName: "Todos",
      avatar: "mdi-animation",
      secondaryFilters: [] as SecondaryFilter[],
      initial: true,
      placeholder:
        "Escriba el nombre de la lista o utiliza los filtros para agrupar información"
    },
    SECONDARY: {
      NAME: {
        name: "Nombre",
        placeholder: "Nombre de Lista",
        key: "name",
        avatar: "mdi-form-textbox",
        type: "secondaryFilter",
        default: true,
        disabled: false,
        operators: OPERATORS_FILTERS,
        display: FILTER_DISPLAY.UNIQUE
      },
      TYPE: {
        name: "Tipo de lista",
        placeholder: "Tipo de Lista",
        key: "listType",
        avatar: "mdi-phone",
        type: "secondaryFilter",
        disabled: false,
        operators: OPERATORS_FILTERS,
        display: FILTER_DISPLAY.LIST,
        options: [] as {
          key: string;
          name: string;
        }[]
      },
      STATUS: {
        name: "Estado",
        placeholder: "Estado de Lista",
        key: "activeList",
        avatar: "mdi-list-status",
        type: "secondaryFilter",
        disabled: false,
        operators: OPERATORS_FILTERS,
        display: FILTER_DISPLAY.LIST,
        options: [
          { name: "Activo", key: "Activo" },
          { name: "Inactivo", key: "Inactivo" }
        ]
      },
      CATEGORY: {
        name: "Categoria",
        placeholder: "Categoria Lista",
        key: "isCategoryList",
        avatar: "mdi-shape",
        type: "secondaryFilter",
        disabled: false,
        operators: OPERATORS_FILTERS,
        display: FILTER_DISPLAY.LIST,
        options: [
          { name: "Habilitado", key: "Activo" },
          { name: "Deshabilitado", key: "Inactivo" }
        ]
      }
    }
  }
};

export const LIST_ACCESS = {
  GET: "consultar listas",
  POST: "crear listas",
  PUT: "modificar listas",
  DELETE: "eliminar listas"
};

export const OPTIONS_EMITS = {
  CLOSE: "modalOptionCancel",
  UPDATE: "updateOptions"
};
